import { createClient } from '@supabase/supabase-js';

const SUPABASE_URL = process.env.REACT_APP_SUPABASE_URL || 'https://wcfprxhopbvxnbsxtanp.supabase.co';
const SUPABASE_ANON_KEY = process.env.REACT_APP_SUPABASE_ANON_KEY || 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6IndjZnByeGhvcGJ2eG5ic3h0YW5wIiwicm9sZSI6ImFub24iLCJpYXQiOjE3NzExMjU0NDEsImV4cCI6MjA4NjcwMTQ0MX0.oszc-l9skXUrCejOgwbu5EqFMfC4RKg5BUc1i2gsgBM';

export const supabase = createClient(SUPABASE_URL, SUPABASE_ANON_KEY);
